// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-theme {
  --bg: #1c1b20;
  --bg-secondary: #2e2d35;
  --bg-item-selected: #2e2d35;
  --bg-item-active: #46464a;
  --text: #ffffff;
  --body-bg: #1c1b20;
  --sidenav-bg: #2e2d35;
  --table-cell-row-hover: #26252b;
  --form-item-label: rgba(255, 255, 255, 1);
  --table-head: #1c1b20;
  --input-border: none;
  --quick-links-bg: #2e2d35;
  --shadow-color: #3730a3;
}

.light-theme {
  --bg: #ffffff;
  --bg-secondary: #fafafa;
  --bg-item-selected: #e6f7ff;
  --bg-item-active: #cef0ff;
  --text: #000000;
  --body-bg: #f8fffb;
  --sidenav-bg: #011932;
  --table-cell-row-hover: #fafafa;
  --form-item-label: rgba(0, 0, 0, 0.85);
  --table-head: rgb(44, 44, 44);
  --input-border: 1px solid #d9d9d9;
  --quick-links-bg: #f4f4f4;
  --shadow-color: #2a4fe2;
}

body {
  background-color: var(--body-bg) !important;
}

.ant-card {
  background-color: var(--bg-secondary) !important;
  color: var(--text) !important;
}

.ant-row {
  color: var(--text) !important;
}

.ant-layout {
  background-color: var(--bg) !important;
}

.ant-page-header-heading-title {
  color: var(--text) !important;
}

.ant-page-header-back-button anticon {
  color: var(--text) !important;
}

.ant-layout-sider {
  background: var(--sidenav-bg) !important;
  
}

.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-menu.ant-menu-dark .ant-menu-sub {
  background: var(--sidenav-bg) !important;
}

.logout-text {
  color: var(--text) !important;
}

.card-body {
  color: var(--text) !important;
}

.ant-typography {
  color: var(--text) !important;
}

.ant-form-item-label>label {
  color: var(--form-item-label) !important;
}

/* .card {
	background-color: var(--bg);
  } */

.ant-table {
  color: var(--text) !important;
}

.ant-table-cell-row-hover {
  background-color: var(--table-cell-row-hover) !important;
}

.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {
  background-color: var(--table-head) !important;
}

.ant-table-thead>tr>th {
  background-color: var(--table-head) !important;
  padding-top: 0.6rem !important;
  padding-bottom: 0.6rem !important;
}

.ant-table-tbody>tr>.ant-table-cell {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.card-header {
  background-color: var(--bg) !important;
}

.card-header>div>h5 {
  color: var(--text) !important;
}

.table-responsive>h5 {
  color: var(--text) !important;
}

.card-custom {
  background-color: var(--bg) !important;
}

.card-custom h5 {
  color: var(--text) !important;
}

.card-custom h4 {
  color: var(--text) !important;
}

.report-section-table,
.detail-account-table {
  color: var(--text) !important;
}

.report-section-table h5,
.detail-account-table h5 {
  color: var(--text) !important;
}

.report-section-table thead,
.detail-account-table thead {
  background-color: var(--table-head) !important;
}

.report-section-table thead th,
.detail-account-table thead th {
  background-color: var(--table-head) !important;
}

.ant-empty-description {
  color: var(--text) !important;
}

.ant-table-placeholder:hover .ant-table-cell {
  background-color: var(--table-cell-row-hover) !important;
}

.loading h5 {
  color: var(--text) !important;
}

.ant-page-header-heading {
  color: var(--text) !important;
}

.ant-page-header-back-button {
  color: var(--text) !important;
}

.range-picker {
  background-color: var(--bg-secondary) !important;
  border: var(--input-border) !important;
}

.ant-picker {
  background-color: var(--bg-secondary) !important;
}

.ant-picker-input>input {
  color: var(--text) !important;
}

.ant-picker-separator,
.ant-picker-suffix,
.ant-picker-clear {
  color: var(--text) !important;
}

.ant-input {
  color: var(--text) !important;
  background-color: var(--bg-secondary) !important;
}

.ant-btn-dashed {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.ant-btn-dashed:hover {
  background-color: var(--bg-secondary) !important;
}

.ant-input-number {
  color: var(--text) !important;
  background-color: var(--bg-secondary) !important;
}

.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,
.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {
  background-color: var(--bg-secondary) !important;
}

.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
  background-color: var(--bg) !important;
}

.ant-input-number-handler-wrap span {
  color: var(--text) !important;
  background-color: var(--bg-secondary) !important;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  color: var(--text) !important;
  background-color: var(--bg-secondary) !important;
}

.ant-select-dropdown {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.ant-select-item .ant-select-item-option {
  color: var(--text) !important;
  background-color: var(--bg-secondary) !important;
}

.ant-select-item-option-content {
  color: var(--text) !important;
}

.ant-select-multiple .ant-select-selection-item {
  background-color: transparent !important;
}

.ant-select-item-option-selected {
  background-color: var(--bg-item-selected) !important;
}

/* .ant-select-item-option-active {
  background-color: var(--bg-item-active) !important;
} */

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: var(--bg-item-active) !important;
}

.dashboard-card {
  color: white;
  border: none;
  border-radius: 10px;
  /* background-color: var(--bg-secondary); */
}

.dashboard-card h3 {
  color: white;
  /* color: var(--text); */
}

.dashboard-card span {
  color: white;
  /* color: var(--text); */
}

.dashboard-card-bg {
  background-color: var(--bg-secondary);
}

.ant-card-head-title {
  color: var(--text) !important;
}

.ant-card-head {
  background-color: var(--bg-secondary) !important;
}

.ant-card-bordered {
  background-color: var(--bg-secondary) !important;
  border: var(--input-border) !important;
}

.ant-page-header {
  background-color: var(--bg-secondary) !important;
  color: var(--text) !important;
  border: var(--input-border) !important;
}

.ant-page-header span {
  color: var(--text) !important;
}

.column-design {
  background-color: var(--bg-secondary) !important;
  border: var(--input-border) !important;
}

.column-design h5 {
  color: var(--text) !important;
}

.ant-select-arrow {
  color: var(--text) !important;
}

.ant-upload.ant-upload-select-picture-card {
  background-color: var(--bg) !important;
}

.ant-upload.ant-upload-select-picture-card div {
  color: var(--text) !important;
}

.ant-upload.ant-upload-select-picture-card .anticon-plus {
  color: var(--text) !important;
}

#csvFileInput {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.ant-dropdown-trigger {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.ant-dropdown-open {
  background-color: var(--bg-secondary) !important;
}

.report-section-card-title {
  color: var(--text) !important;
}

.role-list-title {
  color: var(--text) !important;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link:hover span {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.ant-pagination-item-active {
  color: var(--text) !important;
  background-color: var(--bg) !important;
}

.table-hover {
  color: var(--text) !important;
}

/* ====== REACT SLICK SLIDER - Additional styles to make contents fill full height ====== */

.slick-track {
  display: flex !important;
}

.slick-slide {
  height: inherit !important;
}

.product-single-details .slick-slide>div {
  height: 100% !important;
  width: 100% !important;
  overflow: hidden !important;
  aspect-ratio: 1 / 1 !important;
}

.slick-prev {
  z-index: 10;
  left: 15px !important;
}

.slick-next {
  right: 15px !important;
}

.ant-shadow {
  box-shadow: 0 1px 15px -1px var(--shadow-color), 0 1px 6px -4px var(--shadow-color);
}

/* :where(.css-dev-only-do-not-override-byeoj0).ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:first-child {
  border-start-start-radius: 0px !important;
}

:where(.css-dev-only-do-not-override-byeoj0).ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:last-child {
  border-start-end-radius: 0px !important;
} */


.dark th,
.dark tr,
.dark table {
  color: white !important;
}


:is(.dark .ant-pagination-total-text) {
  color: white !important;
}

:is(.dark .ant-drawer-content) {
  background-color: #2e2d35 !important;
  color: white !important;
}

:is(.dark .ant-drawer-title) {
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,yCAAyC;EACzC,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;;AAE1C;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;KAEK;;AAEL;EACE,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;GAEG;;AAEH;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;EAChD,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;EAEE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2FAA2F;;AAE3F;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mFAAmF;AACrF;;AAEA;;;;;;GAMG;;;AAGH;;;EAGE,uBAAuB;AACzB;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".dark-theme {\n  --bg: #1c1b20;\n  --bg-secondary: #2e2d35;\n  --bg-item-selected: #2e2d35;\n  --bg-item-active: #46464a;\n  --text: #ffffff;\n  --body-bg: #1c1b20;\n  --sidenav-bg: #2e2d35;\n  --table-cell-row-hover: #26252b;\n  --form-item-label: rgba(255, 255, 255, 1);\n  --table-head: #1c1b20;\n  --input-border: none;\n  --quick-links-bg: #2e2d35;\n  --shadow-color: #3730a3;\n}\n\n.light-theme {\n  --bg: #ffffff;\n  --bg-secondary: #fafafa;\n  --bg-item-selected: #e6f7ff;\n  --bg-item-active: #cef0ff;\n  --text: #000000;\n  --body-bg: #f8fffb;\n  --sidenav-bg: #011932;\n  --table-cell-row-hover: #fafafa;\n  --form-item-label: rgba(0, 0, 0, 0.85);\n  --table-head: rgb(44, 44, 44);\n  --input-border: 1px solid #d9d9d9;\n  --quick-links-bg: #f4f4f4;\n  --shadow-color: #2a4fe2;\n}\n\nbody {\n  background-color: var(--body-bg) !important;\n}\n\n.ant-card {\n  background-color: var(--bg-secondary) !important;\n  color: var(--text) !important;\n}\n\n.ant-row {\n  color: var(--text) !important;\n}\n\n.ant-layout {\n  background-color: var(--bg) !important;\n}\n\n.ant-page-header-heading-title {\n  color: var(--text) !important;\n}\n\n.ant-page-header-back-button anticon {\n  color: var(--text) !important;\n}\n\n.ant-layout-sider {\n  background: var(--sidenav-bg) !important;\n  \n}\n\n.ant-menu.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub,\n.ant-menu.ant-menu-dark .ant-menu-sub {\n  background: var(--sidenav-bg) !important;\n}\n\n.logout-text {\n  color: var(--text) !important;\n}\n\n.card-body {\n  color: var(--text) !important;\n}\n\n.ant-typography {\n  color: var(--text) !important;\n}\n\n.ant-form-item-label>label {\n  color: var(--form-item-label) !important;\n}\n\n/* .card {\n\tbackground-color: var(--bg);\n  } */\n\n.ant-table {\n  color: var(--text) !important;\n}\n\n.ant-table-cell-row-hover {\n  background-color: var(--table-cell-row-hover) !important;\n}\n\n.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {\n  background-color: var(--table-head) !important;\n}\n\n.ant-table-thead>tr>th {\n  background-color: var(--table-head) !important;\n  padding-top: 0.6rem !important;\n  padding-bottom: 0.6rem !important;\n}\n\n.ant-table-tbody>tr>.ant-table-cell {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.card-header {\n  background-color: var(--bg) !important;\n}\n\n.card-header>div>h5 {\n  color: var(--text) !important;\n}\n\n.table-responsive>h5 {\n  color: var(--text) !important;\n}\n\n.card-custom {\n  background-color: var(--bg) !important;\n}\n\n.card-custom h5 {\n  color: var(--text) !important;\n}\n\n.card-custom h4 {\n  color: var(--text) !important;\n}\n\n.report-section-table,\n.detail-account-table {\n  color: var(--text) !important;\n}\n\n.report-section-table h5,\n.detail-account-table h5 {\n  color: var(--text) !important;\n}\n\n.report-section-table thead,\n.detail-account-table thead {\n  background-color: var(--table-head) !important;\n}\n\n.report-section-table thead th,\n.detail-account-table thead th {\n  background-color: var(--table-head) !important;\n}\n\n.ant-empty-description {\n  color: var(--text) !important;\n}\n\n.ant-table-placeholder:hover .ant-table-cell {\n  background-color: var(--table-cell-row-hover) !important;\n}\n\n.loading h5 {\n  color: var(--text) !important;\n}\n\n.ant-page-header-heading {\n  color: var(--text) !important;\n}\n\n.ant-page-header-back-button {\n  color: var(--text) !important;\n}\n\n.range-picker {\n  background-color: var(--bg-secondary) !important;\n  border: var(--input-border) !important;\n}\n\n.ant-picker {\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-picker-input>input {\n  color: var(--text) !important;\n}\n\n.ant-picker-separator,\n.ant-picker-suffix,\n.ant-picker-clear {\n  color: var(--text) !important;\n}\n\n.ant-input {\n  color: var(--text) !important;\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-btn-dashed {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.ant-btn-dashed:hover {\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-input-number {\n  color: var(--text) !important;\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number,\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(.ant-input-number-borderless).ant-input-number:hover {\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {\n  background-color: var(--bg) !important;\n}\n\n.ant-input-number-handler-wrap span {\n  color: var(--text) !important;\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  color: var(--text) !important;\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-select-dropdown {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.ant-select-item .ant-select-item-option {\n  color: var(--text) !important;\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-select-item-option-content {\n  color: var(--text) !important;\n}\n\n.ant-select-multiple .ant-select-selection-item {\n  background-color: transparent !important;\n}\n\n.ant-select-item-option-selected {\n  background-color: var(--bg-item-selected) !important;\n}\n\n/* .ant-select-item-option-active {\n  background-color: var(--bg-item-active) !important;\n} */\n\n.ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background-color: var(--bg-item-active) !important;\n}\n\n.dashboard-card {\n  color: white;\n  border: none;\n  border-radius: 10px;\n  /* background-color: var(--bg-secondary); */\n}\n\n.dashboard-card h3 {\n  color: white;\n  /* color: var(--text); */\n}\n\n.dashboard-card span {\n  color: white;\n  /* color: var(--text); */\n}\n\n.dashboard-card-bg {\n  background-color: var(--bg-secondary);\n}\n\n.ant-card-head-title {\n  color: var(--text) !important;\n}\n\n.ant-card-head {\n  background-color: var(--bg-secondary) !important;\n}\n\n.ant-card-bordered {\n  background-color: var(--bg-secondary) !important;\n  border: var(--input-border) !important;\n}\n\n.ant-page-header {\n  background-color: var(--bg-secondary) !important;\n  color: var(--text) !important;\n  border: var(--input-border) !important;\n}\n\n.ant-page-header span {\n  color: var(--text) !important;\n}\n\n.column-design {\n  background-color: var(--bg-secondary) !important;\n  border: var(--input-border) !important;\n}\n\n.column-design h5 {\n  color: var(--text) !important;\n}\n\n.ant-select-arrow {\n  color: var(--text) !important;\n}\n\n.ant-upload.ant-upload-select-picture-card {\n  background-color: var(--bg) !important;\n}\n\n.ant-upload.ant-upload-select-picture-card div {\n  color: var(--text) !important;\n}\n\n.ant-upload.ant-upload-select-picture-card .anticon-plus {\n  color: var(--text) !important;\n}\n\n#csvFileInput {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.ant-dropdown-trigger {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.ant-dropdown-open {\n  background-color: var(--bg-secondary) !important;\n}\n\n.report-section-card-title {\n  color: var(--text) !important;\n}\n\n.role-list-title {\n  color: var(--text) !important;\n}\n\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link:hover span {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.ant-pagination-item-active {\n  color: var(--text) !important;\n  background-color: var(--bg) !important;\n}\n\n.table-hover {\n  color: var(--text) !important;\n}\n\n/* ====== REACT SLICK SLIDER - Additional styles to make contents fill full height ====== */\n\n.slick-track {\n  display: flex !important;\n}\n\n.slick-slide {\n  height: inherit !important;\n}\n\n.product-single-details .slick-slide>div {\n  height: 100% !important;\n  width: 100% !important;\n  overflow: hidden !important;\n  aspect-ratio: 1 / 1 !important;\n}\n\n.slick-prev {\n  z-index: 10;\n  left: 15px !important;\n}\n\n.slick-next {\n  right: 15px !important;\n}\n\n.ant-shadow {\n  box-shadow: 0 1px 15px -1px var(--shadow-color), 0 1px 6px -4px var(--shadow-color);\n}\n\n/* :where(.css-dev-only-do-not-override-byeoj0).ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:first-child {\n  border-start-start-radius: 0px !important;\n}\n\n:where(.css-dev-only-do-not-override-byeoj0).ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:last-child {\n  border-start-end-radius: 0px !important;\n} */\n\n\n.dark th,\n.dark tr,\n.dark table {\n  color: white !important;\n}\n\n\n:is(.dark .ant-pagination-total-text) {\n  color: white !important;\n}\n\n:is(.dark .ant-drawer-content) {\n  background-color: #2e2d35 !important;\n  color: white !important;\n}\n\n:is(.dark .ant-drawer-title) {\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
